import React, { createContext, FC, useContext } from 'react'
import {
	TimeControllerContextProps,
	TimeControllerProviderProps,
} from '@app/hooks/contexts/timeController/timeControllerTypes'
import { timeFormatters } from '@app/hooks/contexts/timeController/formatters'

const timeControllerContextDefault: TimeControllerContextProps = {
	timeLocale: 'us',
	formatters: timeFormatters('us'),
}

const TimeControllerContext = createContext<TimeControllerContextProps>(
	timeControllerContextDefault
)

export const TimeControllerProvider: FC<TimeControllerProviderProps> = ({
	children,
	timeLocale = 'us',
}: TimeControllerProviderProps) => {
	const value = {
		timeLocale,
		formatters: timeFormatters(timeLocale),
	}

	return (
		<TimeControllerContext.Provider value={value}>
			{children}
		</TimeControllerContext.Provider>
	)
}

export const useTimeController = (): TimeControllerContextProps => {
	const value = useContext(TimeControllerContext)

	if (!value)
		// eslint-disable-next-line no-console
		console.error(
			'useTimeController must be used inside TimeControllerProvider'
		)

	return value
}
